import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Form, Modal } from 'react-bootstrap';
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../../../Loader";

const EditTestimonial = (props) => {
  // const [value, setValue] = useState(3);
  const [testimonial, setTestimonial] = useState(null);
  const [image, setImage] = useState(null);
  const token = useSelector((state) => state.token);
  const [loader, setLoader] = useState(false);
  const [imageError, setImageError] = useState(null);
  const getTestimonial = () => {
    setLoader(true);
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/testimonial/${props.testimonialId}`,
    }).then(res => {
      setLoader(false);
      setTestimonial(res.data.testimonial);
    }).catch(err => {
      setLoader(false);
    });
  }

  const updateTestimonial = (data) => {
    setLoader(true);
    const newData = new FormData();
    newData.append("userName", data.userName);
    newData.append("country", data.country);
    newData.append("feedback", data.feedback);
    newData.append("review", data.review);
    newData.append("designation", data.designation);
    if (image) {
      newData.append("image", image[0]);
    }
    axios({
      method: "PUT",
      url: `${process.env.REACT_APP_BASE_URL}/testimonial/${props.testimonialId}`,
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${token}`
      },
      data: newData
    }).then(res => {
      setLoader(false);
      toast(res.data.message, {
        type: "success",
        position: "top-right",
        theme: "light"
      });
      props.getData();
      props.onHide();
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors[0].msg, {
          theme: "light",
          position: "top-right",
          type: "error"
        });
      } else {
        toast(err?.response?.data?.message || err.message || "Failed to update testimonial", {
          theme: "light",
          position: "top-right",
          type: "error"
        });
      }
    });
  }

  useEffect(() => {
    if (!props.show) {
      return;
    }
    getTestimonial();
  }, [props.testimonialId]);

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Edit Testimonial
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="forCountry">
              <Form.Label>Country</Form.Label>
              <Form.Select
                className='form-control'
                aria-label="Default select example"
                value={testimonial?.country}
                onChange={(t) => { setTestimonial((prevState) => ({ ...prevState, country: t.target.value })) }}>
                <option value="United states of america">United states of america</option>
                <option value="Canada">Canada</option>
                <option value="Europe">Europe</option>
                <option value="China">China</option>
                <option value="Nigeria">Nigeria</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="forFeedback">
              <Form.Label>Feedback</Form.Label>
              <Form.Control as="textarea" rows={3} value={testimonial?.feedback} onChange={(t) => { setTestimonial((prevState) => ({ ...prevState, feedback: t.target.value })) }} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="forReview">
              <div className="d-flex align-items-center justify-content-between">
                <Form.Label>Review</Form.Label>
                <div className="bubble" style={{ left: `${(testimonial?.review || 0 - 1) * 25}%` }}>Star : {testimonial?.review || 0}</div>
              </div>
              <Form.Range
                type="range"
                className="form-range"
                min="1"
                max="5"
                step="0.5"
                value={testimonial?.review}
                onChange={(t) => {
                  setTestimonial((prevState) => ({
                    ...prevState,
                    review: t.target.value
                  }));
                }}
                style={{ width: "100%" }}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="forName">
              <Form.Label>User Name</Form.Label>
              <Form.Control type="text" value={testimonial?.userName} onChange={(t) => { setTestimonial((prevState) => ({ ...prevState, userName: t.target.value })) }} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="forDesignation">
              <Form.Label>Designation</Form.Label>
              <Form.Control type="text" value={testimonial?.designation} onChange={(t) => { setTestimonial((prevState) => ({ ...prevState, designation: t.target.value })) }} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="forUserImage">
              <Form.Label>User Image</Form.Label>
              <Form.Control type="file" onChange={(t) => {
                if (t?.target?.files?.[0]?.size > 2 * 1028 * 1028) {
                  return setImageError("File size exceeds 2MB");
                } else if (t?.target?.files?.[0]?.type !== "image/jpg" && t?.target?.files?.[0]?.type !== "image/jpeg" && t?.target?.files?.[0]?.type !== "image/png") {
                  return setImageError("Only support jpg and png");
                }
                setImage(t.target.files)
                setImageError(null);
              }} />
              {imageError ? <p className="errMsg">{imageError}</p> : null}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button className='button blue' onClick={() => {
              if (imageError) {
                return;
              }
              updateTestimonial(testimonial)
            }}>Update</Button>
          </Modal.Footer>
      </Modal>
      <Loader show={loader} />
    </>
  )
}

export default EditTestimonial